import Icon from "@ant-design/icons";

const DashboardIconSVG = (props) => (
  <svg width="20" height={props?.height} viewBox="0 0 20 20" fill="none">
    <path
      d="M8.74935 16.5833V3.41663C8.74935 2.16663 8.21602 1.66663 6.89102 1.66663H3.52435C2.19935 1.66663 1.66602 2.16663 1.66602 3.41663V16.5833C1.66602 17.8333 2.19935 18.3333 3.52435 18.3333H6.89102C8.21602 18.3333 8.74935 17.8333 8.74935 16.5833Z"
      stroke={props?.color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3333 7.09996V3.31663C18.3333 2.14163 17.8 1.66663 16.475 1.66663H13.1083C11.7833 1.66663 11.25 2.14163 11.25 3.31663V7.09163C11.25 8.27496 11.7833 8.74163 13.1083 8.74163H16.475C17.8 8.74996 18.3333 8.27496 18.3333 7.09996Z"
      stroke={props?.color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3333 16.475V13.1083C18.3333 11.7833 17.8 11.25 16.475 11.25H13.1083C11.7833 11.25 11.25 11.7833 11.25 13.1083V16.475C11.25 17.8 11.7833 18.3333 13.1083 18.3333H16.475C17.8 18.3333 18.3333 17.8 18.3333 16.475Z"
      stroke={props?.color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
const DashboardIcon = (props) => (
  <Icon component={() => DashboardIconSVG(props)} {...props} />
);

export default DashboardIcon;
